import styles from "./styles.module.css";
import Image from "@/shared/components/Image/new";

const Notas = ({ sections }) => {
  return (
    <ul className={styles["container"]}>
      {sections &&
        sections.map(({ id, name, content }) => (
          <li key={id} id={id}>
            <h2>{name}</h2>
            <ul className={styles["sections"]}>
              {content.map((el) => {
                const {url : src, title : alt, width, height} = el.img;
                return (
                  <li key={el._id}>
                    <a href={el.url} className={styles["note"]}>
                      <Image
                        src={src}
                        alt={alt}
                        width={width}
                        height={height}
									      className={styles["img"]}
                      />
                      <div className={styles["text"]}>
                        <h4 className={styles["subtitle"]}>{el.subtitle}</h4>
                        <h3 className={styles["title"]}>{el.title}</h3>
                        <div dangerouslySetInnerHTML={{ __html: el.summary }} />
                      </div>
                    </a>
                  </li>
                )})}
            </ul>
          </li>
        ))}
    </ul>
  );
};

export default Notas;
